// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/reversals-report/components/reversals-header/reversals-header.less
// module id = 3971
// module chunks = 0